import clsx from 'clsx';
import React, { ButtonHTMLAttributes } from 'react';
import './BaseButton.less';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
}

export default function BaseButton({ children, fullWidth, ...props }: Props) {
  return (
    <button
      {...props}
      className={clsx('base-button', props.className, {
        'base-button_full-width': fullWidth,
      })}
    >
      {children}
    </button>
  );
}
